<div class="d-grid">
  @if (internalLink) {
    <a class="btn btn-skirt" [routerLink]="link">
      {{ buttonText }}
    </a>
  } @else {
    <a class="btn btn-skirt" [href]="link" target="_blank" rel="opener">
      {{ buttonText }}
    </a>
  }
</div>
